import React from 'react';
import './Button.css';

// Botão "estilo Zara" (pill preto/branco) usado no formulário de produto
// (component/admin/Product/Create.js, classes cp-btn--*) — extraído pra
// shared/ pra ser reusado em qualquer outro form/tela sem duplicar CSS.
const Button = ({ variant = 'primary', type = 'button', className = '', children, ...props }) => (
  <button type={type} className={`svelta-btn svelta-btn--${variant} ${className}`.trim()} {...props}>
    {children}
  </button>
);

export default Button;
